import {UserAttributes, UserType} from "../types/user.type";
import stripeClient               from "../networkClients/stripe-client";
import {useUser}                  from "../context/UserProvider/UserProvider";
import apiClient                  from "../networkClients/api-client";


const updateUserSubscription = async (
    userEmail: string,
    stripeCustomerId: string,
    productId: string
) => {

    try {
        const body: {} = {
            "customer_email": userEmail,
            "action"        : "update-subscription-to-paid",
            "customer_id"   : stripeCustomerId,
            "product_id"    : productId,
        }
        const response = await stripeClient.post<any>("/", body);
        return response.data
    }
    catch (error) {
        console.error(error);
    }
}

const updateUserAttributesOnSignUp = async (
    email: string,
    attributes: UserAttributes
) => {

    try {
        const body: {} = {
            "user_email": email,
            "action"    : "update-user-attributes-on-signup",
            "attributes": attributes,
        }
        const response = await apiClient.post<any>("/cognitointegration", body);
        return response.data
    }
    catch (error) {
        console.error(error);
    }
}

const CognitoUserService = {
    updateUserSubscription, updateUserAttributesOnSignUp
}
export default CognitoUserService;